import Image from 'next/image';
import Link from 'next/link';

import styles from './dark-header.module.scss';

export function Logo() {
    return (
        <Link href="/">
            <Image
                src="/ci/images/landing/icons/udemy-logo-white.svg"
                className={styles.logo}
                alt="Udemy Logo"
                width={96}
                height={32}
            />
        </Link>
    );
}

export function HamburgerIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M4.25 17.634C4.0375 17.634 3.85942 17.5621 3.71575 17.4182C3.57192 17.2746 3.5 17.0964 3.5 16.8837C3.5 16.6712 3.57192 16.4932 3.71575 16.3495C3.85942 16.206 4.0375 16.1342 4.25 16.1342H19.75C19.9625 16.1342 20.1406 16.2061 20.2843 16.3497C20.4281 16.4936 20.5 16.6718 20.5 16.8845C20.5 17.097 20.4281 17.2751 20.2843 17.4187C20.1406 17.5622 19.9625 17.634 19.75 17.634H4.25ZM4.25 12.7495C4.0375 12.7495 3.85942 12.6776 3.71575 12.5337C3.57192 12.3899 3.5 12.2117 3.5 11.9992C3.5 11.7866 3.57192 11.6085 3.71575 11.465C3.85942 11.3213 4.0375 11.2495 4.25 11.2495H19.75C19.9625 11.2495 20.1406 11.3214 20.2843 11.4652C20.4281 11.6091 20.5 11.7872 20.5 11.9997C20.5 12.2124 20.4281 12.3905 20.2843 12.534C20.1406 12.6777 19.9625 12.7495 19.75 12.7495H4.25ZM4.25 7.86474C4.0375 7.86474 3.85942 7.79291 3.71575 7.64924C3.57192 7.50541 3.5 7.32716 3.5 7.11449C3.5 6.90199 3.57192 6.72391 3.71575 6.58024C3.85942 6.43674 4.0375 6.36499 4.25 6.36499H19.75C19.9625 6.36499 20.1406 6.43691 20.2843 6.58074C20.4281 6.72441 20.5 6.90257 20.5 7.11524C20.5 7.32774 20.4281 7.50582 20.2843 7.64949C20.1406 7.79299 19.9625 7.86474 19.75 7.86474H4.25Z"
                fill="white"
            />
        </svg>
    );
}

export function CloseIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.9927 13.0479L6.91969 18.1212C6.78119 18.2595 6.6071 18.3303 6.39744 18.3337C6.18794 18.3368 6.01069 18.266 5.86569 18.1212C5.72085 17.9762 5.64844 17.8005 5.64844 17.5942C5.64844 17.3878 5.72085 17.2122 5.86569 17.0672L10.9389 11.9942L5.86569 6.92115C5.72735 6.78265 5.65652 6.60857 5.65319 6.3989C5.65002 6.1894 5.72085 6.01215 5.86569 5.86715C6.01069 5.72232 6.18635 5.6499 6.39269 5.6499C6.59902 5.6499 6.77469 5.72232 6.91969 5.86715L11.9927 10.9404L17.0657 5.86715C17.2042 5.72882 17.3783 5.65799 17.5879 5.65465C17.7974 5.65149 17.9747 5.72232 18.1197 5.86715C18.2645 6.01215 18.3369 6.18782 18.3369 6.39415C18.3369 6.60049 18.2645 6.77615 18.1197 6.92115L13.0464 11.9942L18.1197 17.0672C18.258 17.2057 18.3289 17.3797 18.3322 17.5894C18.3354 17.7989 18.2645 17.9762 18.1197 18.1212C17.9747 18.266 17.799 18.3384 17.5927 18.3384C17.3864 18.3384 17.2107 18.266 17.0657 18.1212L11.9927 13.0479Z"
                fill="white"
            />
        </svg>
    );
}

export function LanguageIcon() {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
        >
            <path
                d="M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM18.92 8H15.97C15.65 6.75 15.19 5.55 14.59 4.44C16.43 5.07 17.96 6.35 18.92 8ZM12 4.04C12.83 5.24 13.48 6.57 13.91 8H10.09C10.52 6.57 11.17 5.24 12 4.04ZM4.26 14C4.1 13.36 4 12.69 4 12C4 11.31 4.1 10.64 4.26 10H7.64C7.56 10.66 7.5 11.32 7.5 12C7.5 12.68 7.56 13.34 7.64 14H4.26ZM5.08 16H8.03C8.35 17.25 8.81 18.45 9.41 19.56C7.57 18.93 6.04 17.66 5.08 16ZM8.03 8H5.08C6.04 6.34 7.57 5.07 9.41 4.44C8.81 5.55 8.35 6.75 8.03 8ZM12 19.96C11.17 18.76 10.52 17.43 10.09 16H13.91C13.48 17.43 12.83 18.76 12 19.96ZM14.34 14H9.66C9.57 13.34 9.5 12.68 9.5 12C9.5 11.32 9.57 10.65 9.66 10H14.34C14.43 10.65 14.5 11.32 14.5 12C14.5 12.68 14.43 13.34 14.34 14ZM14.59 19.56C15.19 18.45 15.65 17.25 15.97 16H18.92C17.96 17.65 16.43 18.93 14.59 19.56ZM16.36 14C16.44 13.34 16.5 12.68 16.5 12C16.5 11.32 16.44 10.66 16.36 10H19.74C19.9 10.64 20 11.31 20 12C20 12.69 19.9 13.36 19.74 14H16.36Z"
                fill="#F7F9FA"
            />
        </svg>
    );
}
